import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar";
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import AdminSidebar from '../Sidebar/AdminSidebar';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import { FaPen } from "react-icons/fa";
import { Oval } from 'react-loader-spinner';
import CreditRateTable from './CreditRateTable';
import FoodRateTable from './FoodRateTable';
import CreditZoneConfig from './CreditZoneConfig';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';

function ManageCreditCustomerRates() {

  let [showScreen, setShowScreen] = React.useState<any>(1);
  const userLoginData = useSelector((state: any) => state.data.login.value);

  let [shipmentData, setShipmentData] = React.useState<any>({
    companyName: "", phoneNumber: "", email: '', address: '',
    authorizingOfficer: '', banker1: '', banker2: '',
    officerInCharge: '', procedureForPayment: '', pickupDays: '', accountCommencementDate: '',
    advancePaymentDate: '', reviewedBy: '', approvedBy: '', clientAccountNumber: '', dateAccountOpened: '',
  });

  let [loader, setLoader] = React.useState<boolean>(false);
  let [statusModal, setStatusModal] = React.useState<boolean>(false);
  let [approveModal, setApproveModal] = React.useState<boolean>(false);
  let [data, setData] = React.useState<any>([]);

  let [creditCustomers, setCreditCustomers] = React.useState<any>([]);

  // Rate type state
  const [tabNo, setTabNo] = React.useState<any>('0');
  const [customerEmail, setCustomerEmail] = React.useState<any>('');
  const [rateTypeTab, setRateTypeTab] = React.useState<any>('fixed'); // fixed, bulk, flat, multiplier, special, lga, food, zones

  // The active card's zones. How many a card has is configured per customer, and the
  // rate table has to show exactly that many columns — so it is fetched rather than
  // assumed to be four.
  const [cardZones, setCardZones] = React.useState<any[]>([]);

  // Rate data states
  const [fixedRates, setFixedRates] = React.useState<any>([]);
  const [bulkRates, setBulkRates] = React.useState<any>([]);
  const [flatRates, setFlatRates] = React.useState<any>([]);
  const [multiplierRates, setMultiplierRates] = React.useState<any>([]);
  const [specialRates, setSpecialRates] = React.useState<any>([]);
  const [expressRates, setExpressRates] = React.useState<any>([]);

  // NEW: LGA Rate states
  const [lgaDomesticRates, setLgaDomesticRates] = React.useState<any>([]);
  const [lgaBulkRates, setLgaBulkRates] = React.useState<any>([]);
  const [lgaRateTab, setLgaRateTab] = React.useState<any>('domestic'); // domestic or bulk
  const [selectedStateForLga, setSelectedStateForLga] = React.useState<string>('');

  // Available states for filtering
  const availableStates = [
    'Lagos', 'Abuja', 'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa',
    'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu',
    'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi',
    'Kwara', 'Nassarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau',
    'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara', 'FCT'
  ];

  function refreshPage() {
    window.location.reload();
  }

  function toggleStatus(data: any) {
    setData(data)
    setStatusModal(true)
  }

  function toggleApprove(data: any) {
    setData(data)
    setApproveModal(true)
  }

  const updateToReview = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true)
    SuperAdminApis.updateToReview(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setStatusModal(false)
            SuperAdminApis.getAllCreditCustomers('', '').then(
              (response: any) => {
                if (response?.data) {
                  setCreditCustomers(response?.data?.data)
                  setLoader(false)
                  refreshPage();
                }
              }
            )
          }
        }
      }).catch((err: any) => {
        console.log(err);
      })
  }, [data, loader]);

  const updateToApproved = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true)
    SuperAdminApis.updateToApproved(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setApproveModal(false)
            SuperAdminApis.getAllCreditCustomers('', '').then(
              (response: any) => {
                if (response?.data) {
                  setCreditCustomers(response?.data?.data)
                  setLoader(false)
                  refreshPage();
                }
              }
            )
          }
        }
      }).catch((err: any) => {
        console.log(err);
      })
  }, [data, approveModal, loader]);

  const handleShipmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
  }

  React.useEffect(() => {
    SuperAdminApis.getAllCreditCustomers('', '').then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setCreditCustomers(response?.data?.data)
        }
      }
    )
  }, []);

  const [searchText, setSearchText] = React.useState('');

  const paginator = React.useCallback(
    (value: any) => {
      let value2 = '';
      if (value !== null) {
        value2 = value;
      } else {
        value2 = ''
      }

      SuperAdminApis.getAllCreditCustomers(value2, searchText).then(
        (response: any) => {
          if (response?.data) {
            setCreditCustomers(response?.data?.data);
          }
        }
      ).catch(function (error) {
        console.log(error.response.data);
      })
    }, [searchText]);

  const schedule = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    const formData = new FormData()
    formData.append('companyName', shipmentData?.companyName)
    formData.append('phoneNumber', shipmentData?.phoneNumber)
    formData.append('email', shipmentData?.email)
    formData.append('address', shipmentData?.address)
    formData.append('authorizingOfficer', shipmentData?.authorizingOfficer)
    formData.append('banker1', shipmentData?.banker1)
    formData.append('banker2', shipmentData?.banker2)
    formData.append('officerInCharge', shipmentData?.officerInCharge)
    formData.append('procedureForPayment', shipmentData?.procedureForPayment)
    formData.append('pickupDays', shipmentData?.pickupDays)
    formData.append('accountCommencementDate', shipmentData?.accountCommencementDate)
    formData.append('advancePaymentDate', shipmentData?.advancePaymentDate)
    formData.append('reviewedBy', shipmentData?.reviewedBy)
    formData.append('approvedBy', shipmentData?.approvedBy)
    formData.append('clientAccountNumber', shipmentData?.clientAccountNumber)
    formData.append('dateAccountOpened', shipmentData?.dateAccountOpened)

    SuperAdminApis.createCreditCustomer(formData)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setShowScreen(1)
            setLoader(false)
            refreshPage()
          }
        } else {
          toast.error('something went wrong');
        }
      }).catch((err: any) => {
        console.log(err);
        toast.error('something went wrong');
      })
  }, [shipmentData, showScreen, loader]);

  // Load rates when customer is selected
  React.useEffect(() => {
    if (customerEmail && tabNo === '1') {
      loadAllRates(customerEmail);
    }
  }, [customerEmail, tabNo, rateTypeTab, lgaRateTab, selectedStateForLga]);

  React.useEffect(() => {
    const zoned = ['fixed', 'bulk', 'flat', 'multiplier', 'special'];

    if (!customerEmail || !zoned.includes(rateTypeTab)) {
      setCardZones([]);
      return;
    }

    SuperAdminApis.getCreditCustomerZones(customerEmail, rateTypeTab)
      .then((res: any) => setCardZones(res?.data?.data?.zones || []))
      // A card whose zones cannot be read falls back to the default four rather than
      // rendering no columns at all.
      .catch(() => setCardZones([]));
  }, [customerEmail, rateTypeTab]);

  const loadAllRates = (email: string) => {
    // Express is not zone-based: it shares the standard express table, scoped to this
    // customer. An empty list means they are priced on the standard express card.
    if (rateTypeTab === 'express') {
      SuperAdminApis.getAllCreditCustomerExpressRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setExpressRates(response?.data?.data)
          }
        }
      ).catch(() => setExpressRates([]));
    }

    // Load Fixed Rates
    if (rateTypeTab === 'fixed') {
      SuperAdminApis.getCreditCustomerFixedRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setFixedRates(response?.data?.data)
          }
        }
      ).catch(() => setFixedRates([]))
    }

    // Load Bulk Rates
    if (rateTypeTab === 'bulk') {
      SuperAdminApis.getCreditCustomerBulkRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setBulkRates(response?.data?.data)
          }
        }
      ).catch(() => setBulkRates([]))
    }

    // Load Flat Rates
    if (rateTypeTab === 'flat') {
      SuperAdminApis.getCreditCustomerFlatRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setFlatRates(response?.data?.data)
          }
        }
      ).catch(() => setFlatRates([]))
    }

    // Load Multiplier Rates
    if (rateTypeTab === 'multiplier') {
      SuperAdminApis.getCreditCustomerMultiplierRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setMultiplierRates(response?.data?.data)
          }
        }
      ).catch(() => setMultiplierRates([]))
    }

    // Load Special Rates
    if (rateTypeTab === 'special') {
      SuperAdminApis.getCreditCustomerSpecialRates(email).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            setSpecialRates(response?.data?.data)
          }
        }
      ).catch(() => setSpecialRates([]))
    }

    // NEW: Load LGA Rates
    if (rateTypeTab === 'lga') {
      // Load LGA Domestic Rates
      if (lgaRateTab === 'domestic') {
        SuperAdminApis.getCreditCustomerLgaDomesticRates(email, selectedStateForLga || '')
          .then((response: AxiosResponse<any>) => {
            if (response?.data?.status) {
              setLgaDomesticRates(response?.data?.data || []);
            }
          })
          .catch(() => setLgaDomesticRates([]));
      }

      // Load LGA Bulk Rates
      if (lgaRateTab === 'bulk') {
        SuperAdminApis.getCreditCustomerLgaBulkRates(email, selectedStateForLga || '')
          .then((response: AxiosResponse<any>) => {
            if (response?.data?.status) {
              setLgaBulkRates(response?.data?.data || []);
            }
          })
          .catch(() => setLgaBulkRates([]));
      }
    }
  }

  // Upload handlers for existing rate types
  const uploadExpressRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerExpressRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success(response?.data?.message || 'Express rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  const downloadExpressRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerExpressRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_express_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(() => toast.error('Could not download the template'));
  };

  const uploadFixedRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerFixedRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('Fixed rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  const uploadBulkRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerBulkRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('Bulk rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  const uploadFlatRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerFlatRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('Flat rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  const uploadMultiplierRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerMultiplierRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('Multiplier rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  const uploadSpecialRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerSpecialRates(formData).then(
        (response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('Special rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        }
      ).catch(function (error) {
        setLoader(false);
        toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
      })
    }
  };

  // NEW: Upload handlers for LGA rates
  const uploadLgaDomesticRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerLgaDomesticRates(formData)
        .then((response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('LGA domestic rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        })
        .catch(function (error) {
          setLoader(false);
          toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
        })
    }
  };

  const uploadLgaBulkRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      setLoader(true);
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('client_id', customerEmail)

      SuperAdminApis.uploadCreditCustomerLgaBulkRates(formData)
        .then((response: AxiosResponse<any>) => {
          setLoader(false);
          if (response?.data?.status) {
            toast.success('LGA bulk rates uploaded successfully');
            loadAllRates(customerEmail);
          } else {
            toast.warn(response?.data?.message);
          }
        })
        .catch(function (error) {
          setLoader(false);
          toast.error('Upload failed: ' + (error?.response?.data?.message || 'Wrong file format'));
        })
    }
  };

  // Template download handlers
  const downloadFixedRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerFixedRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_fixed_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  const downloadBulkRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerBulkRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_bulk_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  const downloadFlatRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerFlatRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_flat_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  const downloadMultiplierRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerMultiplierRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_multiplier_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  const downloadSpecialRateTemplate = () => {
    SuperAdminApis.downloadCreditCustomerSpecialRateTemplate(customerEmail)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'credit_customer_special_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  // NEW: LGA Template download handlers
  const downloadLgaDomesticRateTemplate = () => {
    SuperAdminApis.downloadLgaDomesticRateTemplate()
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lga_domestic_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success('Template downloaded successfully');
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  const downloadLgaBulkRateTemplate = () => {
    SuperAdminApis.downloadLgaBulkRateTemplate()
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lga_bulk_rate_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success('Template downloaded successfully');
      })
      .catch((error) => {
        toast.error('Template download failed');
      });
  };

  return (
    <>
      <AdminSidebar title="Credit Customer Rates" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">

        {tabNo == "0" ?
          <AdminNavbar title="Credit Customer" />
          :
          <div>
            <AdminNavbar title={`${customerEmail}'s Rates`} />

            <div className='flex justify-between m-5'>
              <div className='flex justify-start gap-2'>
                <button
                  type='button'
                  onClick={() => setTabNo('0')}
                  className="font-normal text-white bg-gray-500 px-3 py-0.5 rounded-md"
                >
                  ← Back to Customers
                </button>
              </div>
            </div>
          </div>
        }

        {tabNo == "0" ?
          <div className="relative bg-[#FAFAFA]">
            <div className={showScreen === 1 ? "block " : "hidden"}>
              <div className='lg:px-10 pb-6 px-6 pt-5 bg-[#FAFAFA] min-h-screen'>

                <div className='flex justify-end mt-5'>
                  <button
                    onClick={() => setShowScreen(2)}
                    type='button'
                    className='bg-[#E04343] rounded-[32px] py-[6px] px-[25px] text-white font-medium'
                  >
                    + Create Customer
                  </button>
                </div>

                <div className={'flex justify-end mt-5'}>
                  <div className='flex gap-3'>
                    <div className="relative w-full">
                      <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                      </div>
                      <input
                        type="text"
                        onChange={(e: any) => setSearchText(e.target.value)}
                        className="bg-white text-gray-900 text-sm rounded-[20px] block w-full pl-10 p-1.5"
                        placeholder="Search customers..."
                        required
                      />
                    </div>

                    <button
                      onClick={() => paginator('')}
                      type='button'
                      className={'bg-[#E04343] rounded-[32px] px-[20px] border-red-100 text-sm text-white'}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <hr className='mt-3 bg-[#C4C4C44D]' />

                <div className="relative overflow-x-auto">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                      <tr>
                        <th scope="col" className="px-2 py-2">S/N</th>
                        <th scope="col" className="px-2 py-2">Company&nbsp;Name</th>
                        <th scope="col" className="px-2 py-2">Phone&nbsp;Number</th>
                        <th scope="col" className="px-2 py-2">Email&nbsp;Address</th>
                        <th scope="col" className="px-2 py-2">Officer&nbsp;Name</th>
                        <th scope="col" className="px-2 py-2">Banker 1</th>
                        <th scope="col" className="px-2 py-2">Banker 2</th>
                        <th scope="col" className="px-2 py-2">Review Status</th>
                        <th scope="col" className="px-2 py-2">Approval Status</th>
                        <th scope="col" className="px-2 py-2">Action</th>
                        <th scope="col" className="px-2 py-2">Rates</th>
                      </tr>
                    </thead>

                    <tbody className=''>
                      {
                        creditCustomers?.data?.map(
                          (datas: any, index: any) => (
                            <tr className="bg-white" key={index}>
                              <td className="px-4 py-2">{index + 1}</td>
                              <td className="px-4 py-4">{datas?.companyName}</td>
                              <td className="px-4 py-4 ">{datas?.phoneNumber}</td>
                              <td className="px-4 py-4">{datas?.email}</td>
                              <td className="px-4 py-4">{datas?.authorizingOfficer}</td>
                              <td className="px-4 py-4">{datas?.banker1}</td>
                              <td className="px-4 py-4">{datas?.banker2}</td>

                              <td className="px-4 py-4">
                                {datas?.reviewStatus == 'Reviewed' ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.reviewStatus}</b></p>
                                  : ''}
                                {datas?.reviewStatus == 'pending' ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.reviewStatus}</b></p>
                                  : ''}
                              </td>

                              <td className="px-4 py-4">
                                {datas?.approvalStatus == 'Approved' ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.approvalStatus}</b></p>
                                  : ''}
                                {datas?.approvalStatus == 'pending' ?
                                  <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.approvalStatus}</b></p>
                                  : ''}
                              </td>

                              <td className="px-4 py-4 cursor-pointer flex justify-between gap-5">
                                <NavLink to={`/admin/view-credit-customers/${datas?.id}`}>
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                                    <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                                    <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                                  </svg>
                                </NavLink>

                                {userLoginData?.email == datas?.reviewedBy ?
                                  <div onClick={() => toggleStatus(datas)} className="mt-1 cursor-pointer">
                                    <FaPen />
                                  </div>
                                  : ''}

                                {userLoginData?.email == datas?.approvedBy ?
                                  <div onClick={() => toggleApprove(datas)} className="mt-1 cursor-pointer">
                                    <FaPen />
                                  </div>
                                  : ''}
                              </td>

                              <td className="px-4 py-4 cursor-pointer gap-5">
                                <button
                                  onClick={() => { setTabNo('1'); setCustomerEmail(datas?.email); setRateTypeTab('fixed'); }}
                                  className="underline text-red-400"
                                >
                                  Manage&nbsp;Rates
                                </button>
                              </td>
                            </tr>
                          )
                        )
                      }
                    </tbody>
                  </table>
                </div>

                <div className='m-4 flex justify-end mt-20'>
                  {
                    creditCustomers?.links?.filter(((item: any, idx: any) => idx < 1000)).map(
                      (datas: any, index: any) => (
                        <button
                          key={index}
                          onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)}
                          disabled={datas?.active}
                          className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}
                        >
                          {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
                        </button>
                      )
                    )
                  }
                </div>

              </div>
            </div>

            {/* Create Customer Form */}
            <div>
              <form onSubmit={schedule}>
                <div className={showScreen === 2 ? "block " : "hidden"}>
                  <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
                    <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">

                      <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                        <div className="relative flex flex-col min-w-0 break-words w-full">
                          <div className="flex-auto py-10 pt-0">
                            <div className="flex flex-wrap">

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Name of Company
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Company Name"
                                    name="companyName"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Telephone Number
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Company Phone Number"
                                    name="phoneNumber"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    E-Mail Address
                                  </label>
                                  <input
                                    type="email"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Company Email"
                                    name="email"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-8/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Registered Address
                                  </label>
                                  <textarea
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Company Address"
                                    name="address"
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Name of Authorizing Officer
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Officer Name"
                                    name="authorizingOfficer"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full mb-5">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Name Of Banker / Branch 1
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Banker / Branch 1"
                                    name="banker1"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Name Of Banker / Branch 2
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="banker / Branch 2"
                                    name="banker2"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                    Name of Officer In Charge Of Mailroom Or Pick Up Point
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Officer Name"
                                    name="officerInCharge"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-8/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    State Briefly The Procedure For Payment
                                  </label>
                                  <textarea
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="Payment Procedure"
                                    name="procedureForPayment"
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Pick up days
                                  </label>
                                  <input
                                    type="text"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder="e.g Mon,Tue,Wed..."
                                    name="pickupDays"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Account Commencement Date
                                  </label>
                                  <input
                                    type="date"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="accountCommencementDate"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    Advanced Payment date
                                  </label>
                                  <input
                                    type="date"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="advancePaymentDate"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    To Be Reviewed By
                                  </label>
                                  <input
                                    type="email"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="reviewedBy"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="w-full lg:w-4/12 lg:pr-4">
                                <div className="relative w-full">
                                  <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                    To Be Approved By
                                  </label>
                                  <input
                                    type="email"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="approvedBy"
                                    onChange={handleShipmentChange}
                                    required
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className='flex justify-center mt-6'>
                      <button
                        type='submit'
                        disabled={loader}
                        className='bg-[#E04343] rounded-[10px] py-[5px] px-[20px] text-white inline-flex'
                      >
                        <div className="flex justify-center gap-3">
                          <span>Create Account</span>
                          <Oval
                            visible={loader}
                            height="20"
                            width="20"
                            color="#E04343"
                            secondaryColor="#FCBF94"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>
          : ""
        }

        {/* Rate Management Section */}
        {tabNo == "1" && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

            {/* Rate Type Tabs */}
            <div className='bg-white rounded-lg p-4 mb-6'>
              <h3 className='text-lg font-semibold mb-4'>Rate Management for {customerEmail}</h3>
              <div className='flex flex-wrap gap-2'>
                <button
                  onClick={() => setRateTypeTab('fixed')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'fixed'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Fixed Rate
                </button>
                <button
                  onClick={() => setRateTypeTab('bulk')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'bulk'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Bulk Rate
                </button>
                <button
                  onClick={() => setRateTypeTab('flat')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'flat'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Flat Rate
                </button>
                <button
                  onClick={() => setRateTypeTab('multiplier')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'multiplier'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Multiplier Rate
                </button>
                <button
                  onClick={() => setRateTypeTab('special')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'special'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Special Rate
                </button>
                <button
                  onClick={() => { setRateTypeTab('lga'); setLgaRateTab('domestic'); }}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'lga'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  LGA Rates
                </button>
                <button
                  onClick={() => setRateTypeTab('food')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'food'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Food Rate
                </button>
                <button
                  onClick={() => setRateTypeTab('express')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'express'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Express Rate
                </button>
                {/* Which states sit in Zone 1-4 for THIS customer. Kept on the
                    same tab bar as the cards because it is the other half of a
                    rate: the cards say what a zone costs, this says what a zone is. */}
                <button
                  onClick={() => setRateTypeTab('zones')}
                  className={`px-4 py-2 rounded-md font-medium transition-colors ${rateTypeTab === 'zones'
                    ? 'bg-[#E04343] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  Zone Configuration
                </button>
              </div>
            </div>

            {/* Food is priced by destination and item type, not by zone, so it brings
                its own table rather than reusing the zone-based one. */}
            {rateTypeTab === 'food' && <FoodRateTable clientEmail={customerEmail} />}

            {/* Express. Priced by destination category rather than zone, so it gets
                no zone columns and no entry on the Zone Configuration tab. */}
            {rateTypeTab === 'express' && (
              <div>
                <div className='bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-6'>
                  <p className='font-semibold text-yellow-900'>How Express Rates Work:</p>
                  <ul className='text-sm text-yellow-800 mt-2 ml-4 list-disc'>
                    <li>Express is priced by <strong>destination category</strong>, not by zone — Lagos Island, Lagos Mainland, South West, Direct (Abuja, Rivers, Edo, Delta) and Nationwide.</li>
                    <li>The <strong>10.01 to 999999</strong> band is not a real weight range: it holds the per-kg amounts charged on top of the 8.1–10kg band for anything over 10kg.</li>
                    <li>If this customer has <strong>no rows here</strong>, their express shipments are priced on the standard express card.</li>
                  </ul>
                </div>

                {expressRates.length === 0 && (
                  <div className='bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4 text-sm text-gray-700'>
                    This customer has no express rates of their own, so they are being charged the
                    standard express rates. Upload or add a band to give them their own.
                  </div>
                )}

                <CreditRateTable
                  type="express"
                  clientEmail={customerEmail}
                  rows={expressRates}
                  loader={loader}
                  onDownloadTemplate={downloadExpressRateTemplate}
                  onUpload={uploadExpressRates}
                  onChanged={() => loadAllRates(customerEmail)}
                />
              </div>
            )}

            {/* Zone configuration. Its own loader and save, so it does not need to
                join loadAllRates — nothing else on this page reads the zone map. */}
            {rateTypeTab === 'zones' && <CreditZoneConfig clientEmail={customerEmail} />}

            {/* Fixed Rate Table */}
            {rateTypeTab === 'fixed' && (
              <CreditRateTable
                type="fixed"
                clientEmail={customerEmail}
                rows={fixedRates}
                loader={loader}
                onDownloadTemplate={downloadFixedRateTemplate}
                onUpload={uploadFixedRates}
                onChanged={() => loadAllRates(customerEmail)}
                zones={cardZones}
              />
            )}
            {/* Bulk Rate Table */}
            {rateTypeTab === 'bulk' && (
              <CreditRateTable
                type="bulk"
                clientEmail={customerEmail}
                rows={bulkRates}
                loader={loader}
                onDownloadTemplate={downloadBulkRateTemplate}
                onUpload={uploadBulkRates}
                onChanged={() => loadAllRates(customerEmail)}
                zones={cardZones}
              />
            )}
            {/* Flat Rate Table */}
            {rateTypeTab === 'flat' && (
              <CreditRateTable
                type="flat"
                clientEmail={customerEmail}
                rows={flatRates}
                loader={loader}
                onDownloadTemplate={downloadFlatRateTemplate}
                onUpload={uploadFlatRates}
                onChanged={() => loadAllRates(customerEmail)}
                zones={cardZones}
              />
            )}
            {/* Multiplier Rate Table */}
            {rateTypeTab === 'multiplier' && (
              <CreditRateTable
                type="multiplier"
                clientEmail={customerEmail}
                rows={multiplierRates}
                loader={loader}
                onDownloadTemplate={downloadMultiplierRateTemplate}
                onUpload={uploadMultiplierRates}
                onChanged={() => loadAllRates(customerEmail)}
                zones={cardZones}
              />
            )}
            {/* Special Rate Table */}
            {rateTypeTab === 'special' && (
              <CreditRateTable
                type="special"
                clientEmail={customerEmail}
                rows={specialRates}
                loader={loader}
                onDownloadTemplate={downloadSpecialRateTemplate}
                onUpload={uploadSpecialRates}
                onChanged={() => loadAllRates(customerEmail)}
                zones={cardZones}
              />
            )}
            {/* NEW: LGA Rates Tab */}
            {rateTypeTab === 'lga' && (
              <div>
                <div className='bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-6'>
                  <p className='font-semibold text-yellow-900'>How LGA Rates Work:</p>
                  <p className='text-sm text-yellow-800 mt-2'>
                    LGA rates are ADDITIONAL costs that are ADDED to the base zone rate. They include:
                  </p>
                  <ul className='text-sm text-yellow-800 mt-2 ml-4 list-disc'>
                    <li><strong>Base Weight:</strong> Starting weight of the range (e.g., 0.5kg)</li>
                    <li><strong>Upper Weight:</strong> Maximum weight of the range (e.g., 10kg)</li>
                    <li><strong>Onforwarding Value:</strong> Fixed cost for shipments within the weight range</li>
                    <li><strong>Add 1kg:</strong> Additional cost per kg if weight exceeds the base</li>
                  </ul>
                </div>

                {/* LGA Rate Type Tabs */}
                <div className='flex gap-2 mb-4'>
                  <button
                    onClick={() => setLgaRateTab('domestic')}
                    className={`px-4 py-2 rounded-md font-medium ${lgaRateTab === 'domestic' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                  >
                    Domestic LGA Rates (0.5-10kg)
                  </button>
                  <button
                    onClick={() => setLgaRateTab('bulk')}
                    className={`px-4 py-2 rounded-md font-medium ${lgaRateTab === 'bulk' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                  >
                    Bulk LGA Rates (20-999kg)
                  </button>
                </div>

                {/* State Filter */}
                <div className='mb-6 flex gap-4 items-center'>
                  <div className='flex-1 max-w-md'>
                    <label className='block text-sm font-medium mb-2'>Filter by State (Optional)</label>
                    <select
                      value={selectedStateForLga}
                      onChange={(e) => setSelectedStateForLga(e.target.value)}
                      className='w-full px-4 py-2 border rounded-md'
                    >
                      <option value="">-- All States --</option>
                      {availableStates.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='flex gap-2 items-end'>
                    <button
                      onClick={lgaRateTab === 'domestic' ? downloadLgaDomesticRateTemplate : downloadLgaBulkRateTemplate}
                      className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-600'
                    >
                      Download Template
                    </button>
                    <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm hover:bg-[#c43939]">
                      {loader ? 'Uploading...' : 'Upload Excel'}
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={lgaRateTab === 'domestic' ? uploadLgaDomesticRates : uploadLgaBulkRates}
                        className="hidden"
                        disabled={loader}
                      />
                    </label>
                  </div>
                </div>

                {/* LGA Domestic Rates Table */}
                {lgaRateTab === 'domestic' && (
                  <div className="relative overflow-x-auto bg-white rounded-lg">
                    <h4 className='font-semibold p-4 text-green-700'>Domestic LGA Rates (0.5kg - 10kg)</h4>
                    <table className="w-full text-sm text-left">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                          <th className="px-6 py-3">S/N</th>
                          <th className="px-6 py-3">LGA Name</th>
                          <th className="px-6 py-3">State</th>
                          <th className="px-6 py-3">Base Weight</th>
                          <th className="px-6 py-3">Upper Weight</th>
                          <th className="px-6 py-3">Onforwarding Value</th>
                          <th className="px-6 py-3">Add 1kg</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lgaDomesticRates.length > 0 ? (
                          lgaDomesticRates
                            .filter((rate: any) => !selectedStateForLga || rate.state_name === selectedStateForLga)
                            .map((rate: any, index: number) => (
                              <tr key={rate.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4">{index + 1}</td>
                                <td className="px-6 py-4">{rate.lga_name}</td>
                                <td className="px-6 py-4">{rate.state_name}</td>
                                <td className="px-6 py-4">{rate.base_weight}kg</td>
                                <td className="px-6 py-4">{rate.upper_weight}kg</td>
                                <td className="px-6 py-4 font-semibold text-green-700">₦{parseFloat(rate.onforwarding_value).toLocaleString()}</td>
                                <td className="px-6 py-4">₦{parseFloat(rate.add_1kg_value).toLocaleString()}</td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={7} className="px-6 py-8 text-center text-gray-500">
                              {selectedStateForLga
                                ? `No domestic LGA rates found for ${selectedStateForLga}. Please upload rates.`
                                : 'No domestic LGA rates found. Please upload rates.'}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* LGA Bulk Rates Table */}
                {lgaRateTab === 'bulk' && (
                  <div className="relative overflow-x-auto bg-white rounded-lg">
                    <h4 className='font-semibold p-4 text-green-700'>Bulk LGA Rates (20kg - 999kg)</h4>
                    <table className="w-full text-sm text-left">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                          <th className="px-6 py-3">S/N</th>
                          <th className="px-6 py-3">LGA Name</th>
                          <th className="px-6 py-3">State</th>
                          <th className="px-6 py-3">Base Weight</th>
                          <th className="px-6 py-3">Upper Weight</th>
                          <th className="px-6 py-3">Onforwarding Value</th>
                          <th className="px-6 py-3">Add 1kg</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lgaBulkRates.length > 0 ? (
                          lgaBulkRates
                            .filter((rate: any) => !selectedStateForLga || rate.state_name === selectedStateForLga)
                            .map((rate: any, index: number) => (
                              <tr key={rate.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4">{index + 1}</td>
                                <td className="px-6 py-4">{rate.lga_name}</td>
                                <td className="px-6 py-4">{rate.state_name}</td>
                                <td className="px-6 py-4">{rate.base_weight}kg</td>
                                <td className="px-6 py-4">{rate.upper_weight}kg</td>
                                <td className="px-6 py-4 font-semibold text-green-700">₦{parseFloat(rate.onforwarding_value).toLocaleString()}</td>
                                <td className="px-6 py-4">₦{parseFloat(rate.add_1kg_value).toLocaleString()}</td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={7} className="px-6 py-8 text-center text-gray-500">
                              {selectedStateForLga
                                ? `No bulk LGA rates found for ${selectedStateForLga}. Please upload rates.`
                                : 'No bulk LGA rates found. Please upload rates.'}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

          </div>
        )}

      </div>

      {/* Review Modal */}
      <section>
        <Modal
          visible={statusModal}
          width="350"
          height="300"
          effect="fadeInUp"
          onClickAway={() => setStatusModal(false)}
        >
          <div className="" style={{ height: '100%', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-2">
              <div className="px-3">
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2'>Update Information</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setStatusModal(false)}>
                    <SvgElement type={icontypesEnum.CANCEL} />
                  </p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  By Clicking on the Reviewed button, you agree to have reviewed this information
                </div>

                <form className="pb-4 rounded-lg" onSubmit={updateToReview}>
                  <span className="flex justify-center pt-4">
                    <button
                      type="submit"
                      disabled={loader}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className="text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center"
                    >
                      <div className="flex justify-center gap-3">
                        <span>Reviewed</span>
                        <Oval
                          visible={loader}
                          height="20"
                          width="20"
                          color="#E04343"
                          secondaryColor="#FCBF94"
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </button>
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setStatusModal(false)}
                      style={{ borderRadius: '50px' }}
                      className="text-black focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center"
                    >
                      Cancel
                    </button>
                  </span>
                </form>
              </div>
            </div>
          </div>
        </Modal>
      </section>

      {/* Approve Modal */}
      <section>
        <Modal
          visible={approveModal}
          width="350"
          height="300"
          effect="fadeInUp"
          onClickAway={() => setApproveModal(false)}
        >
          <div className="" style={{ height: '100%', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-2">
              <div className="px-3">
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2'>Update Information</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setApproveModal(false)}>
                    <SvgElement type={icontypesEnum.CANCEL} />
                  </p>
                </span>

                {data?.reviewStatus == 'pending' ? (
                  <div className='my-10 text-[14px] text-gray-600'>
                    Kindly await {data?.reviewedBy} to review before your approval.
                  </div>
                ) : (
                  <div className='my-10 text-[14px] text-gray-600'>
                    By Clicking on the Approved button, you agree to Approve this information
                  </div>
                )}

                <form className="pb-4 rounded-lg" onSubmit={updateToApproved}>
                  <span className="flex justify-center pt-4">
                    {data?.reviewStatus == 'pending' ? (
                      <button
                        type="submit"
                        disabled
                        style={{ borderRadius: '50px' }}
                        className="text-gray-700 bg-gray-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center"
                      >
                        Awaiting Review
                      </button>
                    ) : (
                      <button
                        type="submit"
                        disabled={loader}
                        style={{ borderRadius: '50px', color: '#F52424' }}
                        className="text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center"
                      >
                        <div className="flex justify-center gap-3">
                          <span>Approve</span>
                          <Oval
                            visible={loader}
                            height="20"
                            width="20"
                            color="#E04343"
                            secondaryColor="#FCBF94"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      </button>
                    )}
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setApproveModal(false)}
                      style={{ borderRadius: '50px' }}
                      className="text-black focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center"
                    >
                      Cancel
                    </button>
                  </span>
                </form>
              </div>
            </div>
          </div>
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export default ManageCreditCustomerRates